import SimulationProductForm from './SimulationProductForm.jsx';
import { Loading } from '@fasstech/middle-design-system';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import useGetSimulationProductQuery from './hooks/useGetSimulationProductQuery.js';

const SimulationProduct = ({ getMiddleText }) => {
  const { getSimulationProduct, loading: isFetchingGetSimulationProduct } =
    useGetSimulationProductQuery();

  if (isFetchingGetSimulationProduct) {
    return <Loading />;
  }

  return (
    <SimulationProductForm
      getSimulationProduct={getSimulationProduct}
      getMiddleText={getMiddleText}
    />
  );
};

export default withMiddleFeatures(SimulationProduct);
